// @ts-check

export default {
    /**
     * @param {HTMLInputElement} el
     */
    created(el) {
        el.addEventListener('input', resizeInput);
        resizeInput.call(el);
    }
};

/**
 * Resize the input element based on its content length.
 */
function resizeInput() {
    this.style.width = this.value.length + 5 + "ch";
}